(function ($) {

    $(function () {

        $(".upcoming-events .event-card").each(function () {
            var $this = $(this);
            var $link = $this.find(".event-card-link");
            var $linkSpan = $link.find("span").detach();
            $link.parent().append($linkSpan);
            $link = $link.detach();
            $this.wrapInner($link);
        });

    });

})($JQ);
